export class NativeStreamScalarOutputField {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "allowedValues",
            "baseName": "allowedValues",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamScalarOutputKind",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamScalarOutputField.attributeTypeMap;
    }
    constructor() {
    }
}
